// This file was automatically generated from print.letter.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.letter');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.physicians');
goog.require('el8.template.fax.letter');
goog.require('el8.template.print.cardiacOrder');
goog.require('el8.template.print.demog');
goog.require('el8.template.print.growthChart');
goog.require('el8.template.print');
goog.require('el8.template.print.imagingOrder');
goog.require('el8.template.print.immunizationHistory');
goog.require('el8.template.print.labOrder');
goog.require('el8.template.print.letter.attachments');
goog.require('el8.template.print.medsList');
goog.require('el8.template.print.messageThreads');
goog.require('el8.template.print.nonvisitNote');
goog.require('el8.template.print.prenatalFlowsheet');
goog.require('el8.template.print.pulmonaryOrder');
goog.require('el8.template.print.refPanel');
goog.require('el8.template.print.referralOrder');
goog.require('el8.template.print.report');
goog.require('el8.template.print');
goog.require('el8.template.print.sleepOrder');
goog.require('el8.template.print.visitNote');
goog.require('el8.template.ptdata.patients');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.letter.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.referralLetter) {
    el8.template.print.referralOrder.content(soy.$$augmentData(opt_data, {order: opt_data.referralOrder, isReferralLetter: true}), output);
  } else {
    if (! opt_data.skipCoverPage) {
      el8.template.print.letter.coverPage(opt_data, output);
    }
  }
  var oList14734 = opt_data.referralOrders;
  var oListLen14734 = oList14734.length;
  for (var oIndex14734 = 0; oIndex14734 < oListLen14734; oIndex14734++) {
    var oData14734 = oList14734[oIndex14734];
    if (! (opt_data.referralLetter && opt_data.referralOrder && opt_data.referralOrder.id == oData14734.id)) {
      el8.template.print.referralOrder.content(soy.$$augmentData(opt_data, {order: oData14734, signDate: opt_data.signDate, signUserName: opt_data.signUserName, signUserType: opt_data.signUserType, isReferralLetter: false}), output);
    }
  }
  if (opt_data.demographics) {
    el8.template.print.demog.content(opt_data, output);
  }
  if (opt_data.medsList) {
    el8.template.print.medsList.content(soy.$$augmentData(opt_data.medsList, {patient: opt_data.patient, practice: opt_data.practice, localFsPath: opt_data.localFsPath, now: opt_data.now}), output);
  }
  if (opt_data.compMedsList) {
    el8.template.print.medsList.comprehensiveContent(soy.$$augmentData(opt_data.compMedsList, {patient: opt_data.patient, practice: opt_data.practice, localFsPath: opt_data.localFsPath, now: opt_data.now}), output);
  }
  if (opt_data.refpanel) {
    el8.template.print.refPanel.content(soy.$$augmentData(opt_data.refpanel, {practice: opt_data.practice, now: opt_data.now, localFsPath: opt_data.localFsPath}), output);
  }
  if (opt_data.immunizationHistory) {
    el8.template.print.immunizationHistory.content(soy.$$augmentData(opt_data.immunizationHistory, {patient: opt_data.patient, practice: opt_data.practice, localFsPath: opt_data.localFsPath, now: opt_data.now}), output);
  }
  var visitNoteList14774 = opt_data.visitNotes;
  var visitNoteListLen14774 = visitNoteList14774.length;
  for (var visitNoteIndex14774 = 0; visitNoteIndex14774 < visitNoteListLen14774; visitNoteIndex14774++) {
    var visitNoteData14774 = visitNoteList14774[visitNoteIndex14774];
    el8.template.print.visitNote.content(soy.$$augmentData(opt_data, {note: visitNoteData14774, showBilling: false, showMu: false}), output);
  }
  var nonvisitNoteList14780 = opt_data.nonvisitNotes;
  var nonvisitNoteListLen14780 = nonvisitNoteList14780.length;
  for (var nonvisitNoteIndex14780 = 0; nonvisitNoteIndex14780 < nonvisitNoteListLen14780; nonvisitNoteIndex14780++) {
    var nonvisitNoteData14780 = nonvisitNoteList14780[nonvisitNoteIndex14780];
    el8.template.print.nonvisitNote.content(soy.$$augmentData(opt_data, {note: nonvisitNoteData14780}), output);
  }
  var rList14784 = opt_data.reports;
  var rListLen14784 = rList14784.length;
  for (var rIndex14784 = 0; rIndex14784 < rListLen14784; rIndex14784++) {
    var rData14784 = rList14784[rIndex14784];
    el8.template.print.report.content(soy.$$augmentData(opt_data, {report: rData14784}), output);
  }
  var oList14788 = opt_data.cardiacOrders;
  var oListLen14788 = oList14788.length;
  for (var oIndex14788 = 0; oIndex14788 < oListLen14788; oIndex14788++) {
    var oData14788 = oList14788[oIndex14788];
    el8.template.print.cardiacOrder.content(soy.$$augmentData(opt_data, {order: oData14788}), output);
  }
  var oList14792 = opt_data.imagingOrders;
  var oListLen14792 = oList14792.length;
  for (var oIndex14792 = 0; oIndex14792 < oListLen14792; oIndex14792++) {
    var oData14792 = oList14792[oIndex14792];
    el8.template.print.imagingOrder.content(soy.$$augmentData(opt_data, {order: oData14792}), output);
  }
  var oList14796 = opt_data.labOrders;
  var oListLen14796 = oList14796.length;
  for (var oIndex14796 = 0; oIndex14796 < oListLen14796; oIndex14796++) {
    var oData14796 = oList14796[oIndex14796];
    if (oData14796.isLabcorpEorder) {
      el8.template.print.labOrder.contentLabCorp(oData14796, output);
    } else {
      el8.template.print.labOrder.content(soy.$$augmentData(opt_data, {order: oData14796}), output);
    }
  }
  var oList14804 = opt_data.pulmonaryOrders;
  var oListLen14804 = oList14804.length;
  for (var oIndex14804 = 0; oIndex14804 < oListLen14804; oIndex14804++) {
    var oData14804 = oList14804[oIndex14804];
    el8.template.print.pulmonaryOrder.content(soy.$$augmentData(opt_data, {order: oData14804}), output);
  }
  var oList14808 = opt_data.sleepOrders;
  var oListLen14808 = oList14808.length;
  for (var oIndex14808 = 0; oIndex14808 < oListLen14808; oIndex14808++) {
    var oData14808 = oList14808[oIndex14808];
    el8.template.print.sleepOrder.content(soy.$$augmentData(opt_data, {order: oData14808}), output);
  }
  if (opt_data.growthCharts && opt_data.growthCharts.length) {
    el8.template.print.growthChart.content(opt_data, output);
  }
  var fsList14815 = opt_data.prenatalFlowsheets;
  var fsListLen14815 = fsList14815.length;
  for (var fsIndex14815 = 0; fsIndex14815 < fsListLen14815; fsIndex14815++) {
    var fsData14815 = fsList14815[fsIndex14815];
    el8.template.print.prenatalFlowsheet.content(soy.$$augmentData(opt_data, {flowsheet: fsData14815}), output);
  }
  var tList14819 = opt_data.messageThreads;
  var tListLen14819 = tList14819.length;
  for (var tIndex14819 = 0; tIndex14819 < tListLen14819; tIndex14819++) {
    var tData14819 = tList14819[tIndex14819];
    el8.template.print.messageThreads.content(soy.$$augmentData(opt_data, {thread: tData14819}), output);
  }
  var lList14823 = opt_data.referencedLetters;
  var lListLen14823 = lList14823.length;
  for (var lIndex14823 = 0; lIndex14823 < lListLen14823; lIndex14823++) {
    var lData14823 = lList14823[lIndex14823];
    el8.template.print.letter.coverPage(lData14823, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.letter.coverPage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  if (! opt_data.isPatientToPhysician) {
    el8.template.print.header(opt_data, output);
  }
  output.append('<div class="letterBody">');
  el8.template.print.letter.letterHeader(opt_data, output);
  output.append('<p class="el8Preserve">', (opt_data.body) ? soy.$$escapeHtml(opt_data.body) : '(No Message Body)', '</p>');
  if (opt_data.signDate && ! opt_data.isPatientToPhysician) {
    if (opt_data.signUserType == 'OfficeStaff') {
      el8.template.print.sentBy(opt_data, output);
    } else {
      el8.template.print.signature({esignatureUrl: opt_data.esignatureUrl, localFsPath: opt_data.localFsPath, signPhysicianName: opt_data.signUserName, signDate: opt_data.signDate}, output);
    }
  }
  if (opt_data.passportUrl) {
    el8.template.fax.letter.passportCta(opt_data, output);
  } else {
    el8.template.print.letter.attachments.tableOfContents(opt_data, output);
  }
  output.append('</div><div width="100%"><p class="mt20 el8Bold">Replies:</p>');
  if (opt_data.comments && opt_data.comments.length) {
    var cList14859 = opt_data.comments;
    var cListLen14859 = cList14859.length;
    for (var cIndex14859 = 0; cIndex14859 < cListLen14859; cIndex14859++) {
      var cData14859 = cList14859[cIndex14859];
      output.append('<p><span>', soy.$$escapeHtml(cData14859.authorName), ', ', (soy.$$escapeHtml(cData14859.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(cData14859.createDate)) : ''), ': ', soy.$$escapeHtml(cData14859.message), '</span></p>');
    }
  } else {
    output.append(' <span>None</span>');
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.letter.letterHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table class="letterOpening" width="100%" border="0" cellspacing="0" cellpadding="0">', (opt_data.deliveryDate || opt_data.signDate) ? '<tr><td class="pt10" width="100%">' + ((opt_data.deliveryDate) ? (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyLongMonthDay(soy.$$escapeHtml(opt_data.deliveryDate)) : '') + ', ' + (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyYear(soy.$$escapeHtml(opt_data.deliveryDate)) : '') : (opt_data.signDate) ? (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyLongMonthDay(soy.$$escapeHtml(opt_data.signDate)) : '') + ', ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyYear(soy.$$escapeHtml(opt_data.signDate)) : '') : '') + '</td></tr>' : '', '<tr><td class="pt20" width="100%">');
  if (opt_data.sendToPatient && ! opt_data.isPatientToPhysician) {
    el8.template.ptdata.patients.displayName(opt_data.patient, output);
    output.append((opt_data.patient.addressLine && opt_data.patient.cityStateZip) ? '<br>' + soy.$$escapeHtml(opt_data.patient.addressLine ? opt_data.patient.addressLine : '') + '<br>' + soy.$$escapeHtml(opt_data.patient.cityStateZip ? opt_data.patient.cityStateZip : '') : '');
  } else if (opt_data.isPatientToPhysician) {
    output.append('From: ');
    el8.template.ptdata.patients.displayName(opt_data.patient, output);
    output.append(' (DOB: ', soy.$$escapeHtml(opt_data.patient.dob), ')');
  } else if (opt_data.displayTo) {
    output.append(soy.$$escapeHtml(opt_data.displayTo));
    if (opt_data.recipient && opt_data.recipient.specialties && opt_data.recipient.specialties.length) {
      output.append('<br>');
      el8.template.data.physicians.specialtyList(opt_data.recipient, output);
    }
    output.append((opt_data.recipient) ? ((opt_data.recipient.fullAddress) ? '<br>' + soy.$$escapeHtml(opt_data.recipient.fullAddress) : '') + ((opt_data.recipient.phone) ? '<br>Office: ' + soy.$$escapeHtml(opt_data.recipient.phone) : '') + ((opt_data.recipient.fax) ? '<br>Fax: ' + soy.$$escapeHtml(opt_data.recipient.fax) : '') + ((opt_data.recipient.email) ? '<br>Email: ' + soy.$$escapeHtml(opt_data.recipient.email) : '') : '');
  } else {
    output.append('(No Recipient)');
  }
  output.append('</td></tr>');
  if (! opt_data.sendToPatient) {
    output.append('<tr><td class="el8Bold pt10" width="100%">Re: ');
    el8.template.ptdata.patients.displayName(opt_data.patient, output);
    output.append(' (DOB: ', soy.$$escapeHtml(opt_data.patient.dob), ')</td></tr>');
  }
  output.append('<tr><td class="el8Bold pt10" width="100%">Subject: ', (opt_data.subject) ? '<span class="el8Bold">' + soy.$$escapeHtml(opt_data.subject) + '</span>' : '(No Subject)', '</td></tr></table>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.letter.replyNotice = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  output.append('<div class="letterBody"><div class="separated">A new message is waiting for you from ', soy.$$escapeHtml(opt_data.sender), '. To view the message and send a reply:<ul class="standardList pt5">', (opt_data.signinUrl) ? '<li>1) Go to ' + soy.$$escapeHtml(opt_data.signinUrl) + '</li><li>2) Choose your account and log in</li>' : '<li>1) Go to ' + soy.$$escapeHtml(opt_data.locateUrl) + '</li><li>2) Enter your last name and your fax number to locate your account</li>', '</ul></div></div></div>');
  if (!opt_sb) return output.toString();
};
